import { isEmpty } from "lodash-es";
import { SuppliersApi, useAPIQuery } from "melco-shared-logic";

export const useGetSupplierProductsBySupplierType = (supplierType?: string) => {
  let { data } = useAPIQuery(
    SuppliersApi,
    ["manageSupplierProductsSearchBySupplierType"],
    async (api) => {
      let response = await api.supplierProductsSearch({
        supplierType:
          supplierType && !isEmpty(supplierType) ? supplierType : "",
      });

      return response;
    }
  );

  return {
    data: data?.list ?? [],
    total: data?.total ?? 0,
    warning_list: data?.warning_list ?? [],
  };
};
